module.exports = __webpack_public_path__ + "img/nerima.2634203c.jpg";